"use client";

import React, { useState, useEffect } from "react";
import { getCategoriesHirarchy } from "../../../services/getAttributes.service";
import { useRouter } from "next/navigation";
import { useSelectedFilters } from "src/store/useSelectedFilters";
import { getLocalizedText } from "src/utils/getLocalizedText";
import { Button } from "src/components/ui/button";

interface Category {
  id: number;
  title_en: string;
  subCategories1: SubCategory1[];
}

interface SubCategory1 {
  id: number;
  title_en: string;
  subCategories2: SubCategory2[];
}

interface SubCategory2 {
  id: number;
  title_en: string;
  subCategories3: any[];
}

const CategoryNavLinkMobile = () => {
  const router = useRouter();
  const [categories, setCategories] = useState<Category[]>([]);
  const {
    // selectedPrice,
    // selectedBrands,
    // selectedSize,
    // selectedConditions,
    // selectedColors,
    // setSelectedPrice,
    // setSelectedBrands,
    // setSelectedSize,
    // setSelectedConditions,
    // setSelectedColors,
    // selectedCategories,
    setSelectedCategories,
    // // selectedSubCategories1,
    // setSelectedSubCategories1,
    // // selectedSubCategories2,
    // setSelectedSubCategories2,
    // // selectedSubCategories3,
    // setSelectedSubCategories3,
  } = useSelectedFilters();

  // Fetch categories on mount
  useEffect(() => {
    const fetchCategories = async () => {
      const data = await getCategoriesHirarchy();
      setCategories(data || []);
    };
    fetchCategories();
  }, []);

  const handleFirstLevel = (category: Category) => {
    setSelectedCategories([category.id]);
    console.log("catogiry is clicked!");
    // ✅ Redirect to category  page
    router.push(
      `/categories/${category.id}?category_level=2&category_name=${encodeURIComponent(category.title_en)}`,
    );
  };

  return (
    <nav className="w-full rounded-none md:hidden">
      <div className="relative">
        {/*  First level - Main categories */}
        <div className="hide flex flex-row items-center justify-start gap-x-5 overflow-x-auto">
          {categories?.map((category, index) => (
            <Button
              key={index}
              className="flex h-9 w-full items-center justify-between rounded-full border bg-transparent px-3 text-left font-light text-black text-opacity-70 hover:bg-gray-50"
              role="button"
              tabIndex={0}
              onClick={() => handleFirstLevel(category)}
            >
              <p>{getLocalizedText(category, "title")}</p>
            </Button>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default CategoryNavLinkMobile;
